<div class="board-header">
  <div class="board-bar">
    <p-dropdown class="pp-dropdown" (onChange)="updatePeriods($event.value.start, $event.value.finish)"
                [options]="lastPayPeriods" [(ngModel)]="selectedPayPeriod" optionLabel="finish"
                placeholder="Pay Period">
      <ng-template let-item pTemplate="selectedItem">
        {{item?.startDate | date:'MMM d'}} - {{item?.finishDate | date:'MMM d, y'}}
      </ng-template>
      <ng-template let-item pTemplate="item">
        {{item?.startDate | date:'MMM d'}} - {{item?.finishDate | date:'MMM d, y'}}
      </ng-template>
    </p-dropdown>


    <button mat-button class="board-button" (click)="printAll()" [disabled]="selectedApprovalCounter < 1"
            [ngClass]="{'disabled-header-button': selectedApprovalCounter < 1}" *ngIf="!isMobile">
      Print selected payments
    </button>
    <div style="flex: 1;"></div>
    <div class="dev-block" *ngIf="currentUser.adminRole">

      <p-dropdown #usersDropdown class="users-dropdown" [options]="users" [(ngModel)]="selectedUser"
                  optionLabel="username"
                  *ngIf="showUsersDropdown">
      </p-dropdown>

      <input class="fill-input" matInput [(ngModel)]="hoursToFill" placeholder="Hours" type="number"
             autocomplete="off" [min]="0" [max]="160">
      <div class="fill-button" (click)="fillHours()">
        <button class="fill-btn" mat-button [disabled]="!hoursToFill || (hoursToFill <= 0 || hoursToFill > 160)"
                [ngClass]="{'disabled-header-button': !hoursToFill || (hoursToFill <= 0 || hoursToFill > 160)}">Fill
        </button>
      </div>

      <button mat-button class="csv-button" (click)="openCsvDialog()">
        CSV
      </button>
    </div>
  </div>
</div>

<div class="approval-middle">

  <div class="approvals-block">
    <div class="approval header-block">
      <div class="checkmark-block" *ngIf="!isMobile">
        <p-checkbox [binary]="true" [(ngModel)]="showAll" (onChange)="toggleAll($event)"></p-checkbox>
      </div>
      <div class="buttons-block">
        <span style="font-size: 135%">Actions</span>
      </div>
      <div class="user-block">
        <div class="user-name">User</div>
      </div>
      <div class="hours-block">
        <div class="hours">
          Hours
        </div>
        <div class="add-info">
          <span class="ot" style="font-size: 110%">Overtime</span>
          <span class="vac" style="font-size: 110%">Vacation Hours</span>
          <span class="sick" style="font-size: 110%">Sick Hours</span>
          <span class="total" style="font-size: 110%">Total Hours</span>
          <span class="pb" style="font-size: 110%">Paid Breaks</span>
          <span class="upb" style="font-size: 110%">Unpaid Breaks</span>
        </div>
      </div>
      <div class="cbs-block" *ngIf="!isMobile">
        <span class="outside" style="font-size: 110%">SRT</span>
      </div>
      <div class="outside-block" *ngIf="!isMobile">
        <span class="outside" style="font-size: 110%">Outside Shop</span>
      </div>
      <div class="print-block" *ngIf="!isMobile">
        <span style="font-size: 135%">Print</span>
      </div>
    </div>

    <div class="approval approvals-to-print" *ngFor="let approval of approvalsToPrint; let i = index"
         [ngClass]="{'approoved': approval.payPeriod.approved, 'first-contractor-user': i === contractorIndex, 'last-not-contractor-user': i === contractorIndex-1}">
      <div class="checkmark-block" *ngIf="!isMobile">
        <p-checkbox [binary]="true" [(ngModel)]="approval.selected"
                    (onChange)="toogleToPrint($event)"></p-checkbox>
      </div>
      <div class="buttons-block">
        <button mat-button (click)="approve(approval.payPeriod)" class="approve-button"
                [ngClass]="{'disabled-button': !approval.payPeriod.user.trackWorkTime, 'approved': approval.payPeriod.approved}">
          <span *ngIf="!approval.payPeriod.approved">Approve</span>
          <span *ngIf="approval.payPeriod.approved">Unapprove</span>
        </button>
      </div>
      <div class="user-block" (click)="openSheets(approval.payPeriod)"
           [ngClass]="{'clickable': !isMobile && approval.payPeriod.user.trackWorkTime}">
        <div class="user-name">{{approval.payPeriod.user.lastName}} {{approval.payPeriod.user.firstName}}</div>

        <div class="work-type">
					<span *ngIf="approval.payPeriod.user.punchStatus === 'WORK'" class="work-label type-label"
                pTooltip="{{approval.payPeriod.currentJob?.name}}" tooltipPosition="bottom"></span>
          <span *ngIf="approval.payPeriod.user.punchStatus === 'UNPAID_BREAK'" class="unpaid-label type-label"
                pTooltip="Unpaid Break" tooltipPosition="bottom"></span>
          <span *ngIf="approval.payPeriod.user.punchStatus === 'PAID_BREAK'" class="paid-label type-label"
                pTooltip="Paid Break" tooltipPosition="bottom"></span>
          <span *ngIf="approval.payPeriod.user.punchStatus === 'VACATION'" class="vacation-label type-label"
                pTooltip="Vacation" tooltipPosition="bottom"></span>
        </div>
      </div>
      <div class="hours-block">
        <div class="hours">
					<span class="wt">
						{{((approval.payPeriod.workDuration) / 60) | number:'1.2-2'}} hrs
					</span>

        </div>
        <div class="add-info">
          <span class="ot" step="0.25"
                [ngClass]="{'red-time': approval.payPeriod.overtimeWorkDuration > 0}">{{(approval.payPeriod.overtimeWorkDuration / 60) | number:'1.2-2'}}
            hrs</span>
          <span class="vac" step="0.25"
                [ngClass]="{'vac-time': approval.payPeriod.vacationHoursDuration > 0}">{{(approval.payPeriod.vacationHoursDuration / 60) | number:'1.2-2'}}
            hrs</span>
          <span class="sick" step="0.25" [ngClass]="{'sick-time': approval.payPeriod.sickHoursDuration > 0}">
            {{(approval.payPeriod.sickHoursDuration / 60) | number:'1.2-2'}} hrs
					</span>
          <span class="total" step="0.25">{{(approval.payPeriod.totalTimeDuration / 60) | number:'1.2-2'}}
            hrs</span>
          <span class="pb">{{(approval.payPeriod.paidBreaksDuration / 60) | number:'1.2-2'}} PB </span>
          <span class="upb">{{(approval.payPeriod.unpaidBreaksDuration / 60) | number:'1.2-2'}} UPB</span>
        </div>
      </div>
      <div class="cbs-block" *ngIf="!isMobile">
        <div class="unresolved">
          <ng-container *ngIf="approval.payPeriod.unresolvedCards > 0">
            {{approval.payPeriod.unresolvedCards}}
          </ng-container>
        </div>
        <div class="resolved">
          <ng-container *ngIf="approval.payPeriod.resolvedCards > 0">
          {{approval.payPeriod.resolvedCards}}
          </ng-container>
        </div>
      </div>
      <div class="outside-block" *ngIf="!isMobile">
				<span class="outside"><span
          *ngIf="approval.payPeriod.clockInsOutsideShop > 0 || approval.payPeriod.clockOutsOutsideShop > 0">{{approval.payPeriod.clockInsOutsideShop + approval.payPeriod.clockOutsOutsideShop}}</span></span>


      </div>
      <div class="print-block" *ngIf="!isMobile">
        <button mat-button (click)="openPdfPeriod(approval.payPeriod)" class="print-button">
          <mat-icon class="print-icon">print</mat-icon>
        </button>

      </div>
    </div>

  </div>
  <div class="rightside-panel" *ngIf="!isMobile">
    <div class="panel-title">
      Changes History
    </div>
    <div class="panel-content">
      <div class="change-block" *ngFor="let edit of changes">
        {{edit.title}}
      </div>
    </div>
  </div>
  <div class="approvals-spinner-box" *ngIf="loadingSpinnger">
    <lib-progress-spinner></lib-progress-spinner>
  </div>
</div>
